<template>
  <div>
    <vxe-grid
      ref="skuTable"
      size="small"
      row-id="key"
      cell-class-name="align-top"
      auto-resize
      resizable
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="data"
      :columns="tableColumns"
      :loading="loading"
      :height="800"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ trigger: 'row', highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:100%;"
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" style="width:100%;" />
          </div>
        </el-image>
      </template>

      <template v-slot:displaySkuName="{ row }">
        <div>{{ row.goodsName }}</div>
        <div>{{ row.goodsNameEn }}</div>
        <div>
          <span>NC:</span><span style="color: #409EFF">{{ row.ncNo }}</span>
        </div>
        <div>
          <span>SKU:</span>
          <span style="color: #409EFF">{{ row.amzSkuNo }}</span>
        </div>
        <div>
          <span>FTY NC:</span
          ><span style="color: #409EFF">{{ row.ftyNcNo }}</span>
        </div>
      </template>

      <template v-slot:displayBrand="{ row }">
        <span>BRAND:</span
        ><span style="color: #303133">{{ row.brandName }}</span>
        <br />
        <span>CATEGORY:</span
        ><span style="color: #303133">{{ row.masterCategoryName }}</span>
      </template>

      <template v-slot:displayStore="{ row }">
        <span>NO:</span><span>{{ row.amzStoreNo }}</span>
        <br />
        <span>NAME:</span><span>{{ row.amzStoreName }}</span>
        <br />
        <span>BRAND:</span><span>{{ row.storeBrandName }}</span>
      </template>

      <template v-slot:displaySalesTitle="{ row }">
        <span style="color: #303133">{{ row.salesTitle }}</span>
        <br />
        <span>SKU:</span
        ><span style="color: #409EFF">{{ row.storeSkuNo }}</span>
        <br />
        <span>ASIN:</span><span style="color: #409EFF">{{ row.asinCode }}</span>
        <br />
        <span>FNSKU:</span
        ><span style="color: #409EFF">{{ row.fnskuCode }}</span>
        <br />
        <span>UPC:</span
        ><span style="color: #409EFF">{{ row.upc }}</span>
      </template>

      <template v-slot:displaySize="{ row }">
        <span>SIZE:</span
        ><span style="color: #303133">{{ row.goodsSize }}</span>
        <br />
        <span>COLOR:</span
        ><span style="color: #303133">{{ row.goodsColor }}</span
        ><span style="color: #303133">{{ row.goodsColorEn }}</span>
        <br />
        <span>Pattern:</span
        ><span style="color: #303133">{{ row.goodsPattern }}</span>
        <br />
        <span>Style:</span
        ><span style="color: #303133">{{ row.goodsStyle }}</span>
      </template>

      <template v-slot:displayFty="{ row }">
        <div>
          <span>{{ $l('INDEX.table_label_totalInvCtnQty') }}:</span>
          <span style="color: #409EFF">{{ row.invCtnQty || 0 }}</span>
        </div>
        <div v-if="row.listInv" class="display_FtyInv">
          <div v-for="(inv, index) in row.listInv" :key="index">
            <div>
              <span>{{ $l('INDEX.table_label_invInCtnQty') }}:</span>
              <span style="color: #409EFF">{{ inv.inCtnQty }}</span>
            </div>
            <div>
              <span>{{ $l('INDEX.table_label_invCtnQty') }}:</span>
              <span style="color: #409EFF">{{ inv.ctnQty }}</span>
            </div>
          </div>
        </div>
      </template>

      <template v-slot:displayUnit="{ row }">
        <span>UNIT:</span
        ><span style="color: #303133"
          >{{ row.unitLength }}x{{ row.unitWidth }}x{{
            row.unitHeight
          }}
          cm</span
        >
        <br />
        <span>N.W:</span
        ><span style="color: #303133">{{ row.goodsWeight }} kg</span>
        <br />
        <span>G.W:</span
        ><span style="color: #303133">{{ row.unitWeight }} kg</span>
        <br />
        <span>CBM:</span
        ><span style="color: #303133">{{ row.unitCbm }} m³</span>
      </template>

      <template v-slot:displayBox="{ row }">
        <span
          >CTN:{{ row.ctnLength }}x{{ row.ctnWidth }}x{{
            row.ctnHeight
          }}
          cm</span
        >
        <br />
        <span>N.W:{{ row.ctnNetWeight }} kg</span>
        <br />
        <span>G.W:{{ row.ctnGrossWeight }} kg</span>
        <br />
        <span>CBM:{{ row.ctnCbm }} m³</span>
      </template>

      <template v-slot:displayHscodeName="{ row }">
        <div>{{ row.hscodeCn }}</div>
        <div>{{ row.hscodeName }}</div>
        <div>{{ row.hscodeNameEn }}</div>
      </template>

      <template v-slot:displayDesignName="{ row }">
        <span>DESIGN:</span
        ><span style="color: #303133">{{ row.designName }}</span>
        <br />
        <span>BUYER:</span
        ><span style="color: #303133">{{ row.buyerName }}</span>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    hasVc: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    data() {
      if (!this.tableData?.length) return []
      return this.tableData.map((row) => {
        return { ...row, key: `${row.amzSkuStoreCode}-${row.amzSkuFtyCode}` }
      })
    },
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
  },
}
</script>
<style lang="scss" scoped>
.display_FtyInv {
  > div {
    margin-bottom: 5px;
    display: flex;
    div:first-child {
      margin-right: 10px;
    }
  }
}
</style>
